export default __webpack_public_path__ + "static/media/ohLogoSp.8901b564.svg";